Ext.define('SA.data.scatterplot.ScatterPlotConfig', {
    axisFontColor: '#727a8b',
    axisFontSize: 12,
    axisStrokeColor: '#aaafb9',
    axisTitleFontColor: '#2c3852',
    axisTitleFontSize: 14,
    fontFamily: 'LatoLatinWeb, Lato',
    fontVariant: 'no-common-ligatures',
    gridLineColor: '#eee',
    legendFontColor: '#344365',
    legendFontSize: 13,
    legendMarginLeft: 50,
    legendSectionSpacing: 15,
    legendSymbolColumnWidth: 30,
    legendTextOpacity: 0.8,
    legendWidth: 200,
    letterSpacing: 0.2,
    lineHeight: 1.333333333,
    lineOfBestFitDashArray: 5,
    lineOfBestFitStroke: 'orange',
    lineOfBestFitStrokeWidth: 1,
    marginBottom: 30,
    marginLeft: 50,
    marginRight: 50,
    marginTop: 30,
    pointHoveredRadiusIncrease: 1,
    pointSelectedRadiusIncrease: 2,
    pointStrokeDarkerFactor: 0.08,
    pointStrokeWidth: 1,
    titleFontColor: '#2c3852',
    titleFontSize: 15,
    titleMarginBottom: 36,
    xAxisBaseWidth: 600,
    xAxisHeight: 35,
    xAxisTickCount: 10,
    yAxisBaseHeight: 320,
    yAxisTickCount: 10,
    yAxisWidth: 65,

    statics: {
        forChartSize(chartWidth, chartHeight) {
            var cfg = this.prototype,
                axisTitleHeight = lines => lines * cfg.axisTitleFontSize * cfg.lineHeight,
                assumedXAxisHeight = cfg.xAxisHeight + axisTitleHeight(2),
                assumedYAxisWidth = cfg.yAxisWidth + axisTitleHeight(3),
                assumedMaxXAxisWidth = chartWidth - assumedYAxisWidth,
                assumedMaxYAxisHeight = chartHeight - assumedXAxisHeight,
                scale;

            if (assumedMaxXAxisWidth / assumedMaxYAxisHeight <= cfg.xAxisBaseWidth / cfg.yAxisBaseHeight) {
                scale = assumedMaxXAxisWidth / cfg.xAxisBaseWidth;
            }
            else {
                scale = assumedMaxYAxisHeight / cfg.yAxisBaseHeight;
            }

            scale = Ext.Number.constrain(scale, 1, 2);

            return new this({xAxisWidth: cfg.xAxisBaseWidth * scale, yAxisHeight: cfg.yAxisBaseHeight * scale});
        },

        forExport() {
            var inchesWidth = 11, 
                inchesHeight = 8.5, 
                pixelsPerInch = 96, 
                pixelsWidth = inchesWidth * pixelsPerInch,
                pixelsHeight = inchesHeight * pixelsPerInch,
                cfg = this.prototype,
                assumedTitleHeight = 2 * cfg.titleFontSize * cfg.lineHeight + cfg.titleMarginBottom, 
                legendWidth = cfg.legendMarginLeft + cfg.legendWidth,
                chartWidth = pixelsWidth - legendWidth - cfg.marginLeft - cfg.marginRight,
                chartHeight = pixelsHeight - assumedTitleHeight - cfg.marginTop - cfg.marginBottom;

            return this.forChartSize(chartWidth, chartHeight);
        },

        forViewport(width, height) {
            var cfg = this.prototype,
                chartWidth = width - cfg.marginLeft - cfg.marginRight - Ext.getScrollbarSize().width,
                chartHeight = height - cfg.marginTop - cfg.marginBottom - Ext.getScrollbarSize().height;

            return this.forChartSize(chartWidth, chartHeight);
        }
    },

    constructor(cfg) {
        Object.assign(this, cfg);
    },

    getAxisTitleStyle(width) {
        return {
            color: this.axisTitleFontColor,
            fontFamily: this.fontFamily,
            fontSize: `${this.axisTitleFontSize}px`,
            fontVariant: this.fontVariant,
            letterSpacing: `${this.letterSpacing}px`,
            lineHeight: this.lineHeight,
            textAlign: 'center',
            width: `${width}px`
        };
    },

    getLegendTextStyle() {
        return {
            color: this.legendFontColor,
            fontFamily: this.fontFamily,
            fontSize: `${this.legendFontSize}px`,
            fontVariant: this.fontVariant,
            letterSpacing: `${this.letterSpacing}px`,
            lineHeight: this.lineHeight,
            maxWidth: `${this.legendWidth - this.legendSymbolColumnWidth}px`,
            opacity: this.legendTextOpacity
        };
    }
});